import { useEffect, useState } from 'react';
import { getOutcomeList } from 'services/CaseServices';

const useCaseOutcome = (params) => {
  const { isLead = false } = params || {};
  const [caseOutcomeList, setCaseOutcomeList] = useState([]);
  const [isCaseOutComeLoading, setisCaseOutComeLoading] = useState(false);

  const loadCaseOutcome = () => {
    setisCaseOutComeLoading(true);
    getOutcomeList(isLead)
      .then((response) => {
        let outcomeData = [];
        if (response?.data) {
          outcomeData = response?.data?.map((val) => {
            return { label: val.outcome_reason, value: val.outcome_reason };
          });
        }
        setCaseOutcomeList(outcomeData);
      })
      .catch((err) => {
        console.log('err', err);
        setCaseOutcomeList([]);
      })
      .finally(() => setisCaseOutComeLoading(false));
  };

  useEffect(() => {
    loadCaseOutcome();
  }, []);

  return { caseOutcomeList, isCaseOutComeLoading };
};

export default useCaseOutcome;
